/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NormalOrderCheckInfoVo } from './NormalOrderCheckInfoVo';
import {
    NormalOrderCheckInfoVoFromJSON,
    NormalOrderCheckInfoVoFromJSONTyped,
    NormalOrderCheckInfoVoToJSON,
    NormalOrderCheckInfoVoToJSONTyped,
} from './NormalOrderCheckInfoVo';

/**
 * 
 * @export
 * @interface ResponseNormalOrderCheckInfoVo
 */
export interface ResponseNormalOrderCheckInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseNormalOrderCheckInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseNormalOrderCheckInfoVo
     */
    message?: string;
    /**
     * 
     * @type {NormalOrderCheckInfoVo}
     * @memberof ResponseNormalOrderCheckInfoVo
     */
    data?: NormalOrderCheckInfoVo;
}

/**
 * Check if a given object implements the ResponseNormalOrderCheckInfoVo interface.
 */
export function instanceOfResponseNormalOrderCheckInfoVo(value: object): value is ResponseNormalOrderCheckInfoVo {
    return true;
}

export function ResponseNormalOrderCheckInfoVoFromJSON(json: any): ResponseNormalOrderCheckInfoVo {
    return ResponseNormalOrderCheckInfoVoFromJSONTyped(json, false);
}

export function ResponseNormalOrderCheckInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseNormalOrderCheckInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : NormalOrderCheckInfoVoFromJSON(json['data']),
    };
}

export function ResponseNormalOrderCheckInfoVoToJSON(json: any): ResponseNormalOrderCheckInfoVo {
    return ResponseNormalOrderCheckInfoVoToJSONTyped(json, false);
}

export function ResponseNormalOrderCheckInfoVoToJSONTyped(value?: ResponseNormalOrderCheckInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': NormalOrderCheckInfoVoToJSON(value['data']),
    };
}

